import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { MOBILE_BREAK_POINT } from './constants';

export const BodyWrapper = styled(Box)(({ theme }) => ({
	gridArea: 'body',
	display: 'grid',
	gridTemplateColumns: '60px 1fr 1fr 60px',
	gridTemplateAreas: `"leftPadding  Box1 Box2 rightPadding"
	"leftPadding  footer footer rightPadding"`,
	gridTemplateRows: '1fr 60px',
	backgroundColor: 'transparent',
	maxHeight: 'calc(100vh - 84px)',
	height: 'calc(100vh - 84px)',
	position: 'relative',
	zIndex: 1,
	'& > *': {
		backdropFilter: 'blur(30px) saturate(40%)',
		WebkitBackdropFilter: 'blur(30px) saturate(40%)',
		backgroundColor:
			theme.palette.mode === 'dark'
				? 'rgba(8, 10, 18, 0.3)'
				: 'rgba(255, 255, 255, 0.38)',
	},

	[`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
		gridTemplateColumns: '8px 1fr 8px',
		gridTemplateAreas: `"leftPadding Box1 rightPadding"
		"leftPadding Box2 rightPadding"
		"leftPadding footer rightPadding"`,
		gridTemplateRows: 'auto auto 60px',
		maxHeight: '100vh',
		height: '100vh',
	},
}));

export const Box1 = styled(Box)({
	gridArea: 'Box1',
	display: 'grid',
	gridTemplateRows: '2fr 1.1fr',
	height: 'calc(100vh - 144px)',

	[`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
		gridTemplateRows: 'auto',
		height: 'auto',
		minHeight: '45vh',
		marginTop: '60px',
	},
});

export const Box2 = styled(Box)({
	gridArea: 'Box2',
	display: 'grid',
	gridTemplateRows: '1fr 1fr',
	position: 'relative',

	height: 'calc(100vh - 144px)',

	[`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
		gridTemplateRows: 'auto',
		height: 'auto',
		minHeight: 'calc(40vh - 133px)',
	},
});

export const RightTopBox = styled(Box)({
	backgroundColor: 'transparent',

	[`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
		display: 'none',
	},
});

export const RightBottomBox = styled(Box)({
	position: 'relative',
});

export const LeftPadding = styled('div')(({ theme }) => ({
	gridArea: 'leftPadding',
	width: 60,
	borderRight: `1px solid ${theme.palette.atlas.border.default}`,
	height: '100%',

	[`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
		width: 8,
	},
}));

export const RightPadding = styled('div')(({ theme }) => ({
	gridArea: 'rightPadding',
	width: 60,
	borderLeft: `1px solid ${theme.palette.atlas.border.default}`,
	height: '100%',

	[`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
		width: 8,
	},
}));
